import * as Sentry from '@sentry/browser';
import { getAppVersion } from 'qs-helpers';
import { getCompanyIdFromCache } from 'qs-data-manager/Company';

export const setSentryContext = ({ userId, email, companyId }) => {
  const appVersion = getAppVersion();
  Sentry.configureScope(scope => {
    scope.setUser({ id: userId, email, companyId, appVersion });
  });
};

export const resetSentryUser = () => {
  Sentry.configureScope(scope => scope.setUser(null));
};

export const reportError = (error, options = {}) => {
  Sentry.captureException(error, options);
};

const normalizeUploadError = (step, error) => {
  if (error instanceof Error) {
    return error;
  }
  if (typeof error === 'string') {
    return new Error(`[ImageUpload:${step}] ${error}`);
  }
  const message = (error && (error.message || (error.error && error.error.message))) || 'unknown';
  return new Error(`[ImageUpload:${step}] ${message}`);
};

export const reportImageUploadError = ({
  step,
  error,
  pictureId,
  productId,
  catalogueId,
  retryCount,
  calledFrom
} = {}) => {
  try {
    Sentry.captureException(normalizeUploadError(step, error), {
      tags: { uploadStep: step, calledFrom },
      extra: {
        step,
        pictureId,
        productId,
        catalogueId,
        retryCount,
        calledFrom,
        companyId: getCompanyIdFromCache(),
        rawError:
          typeof error === 'string'
            ? error
            : error && {
                message: error.message,
                name: error.name,
                inner: error.error && (error.error.message || error.error)
              }
      }
    });
  } catch (loggingFailure) {
    // Never let logging itself break the upload flow
  }
};
